<template>
  <div class="progress">
    <div
      v-for="answer in answers"
      v-tooltip="getTitle(answer)"
      class="progress-bar"
      role="progressbar"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-valuenow="answer.percentage_numeric"
      :style="calculateStyle(answer)"
    >
      <span :class="getIconClass(answer.answer)" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'LikeQuestionResultBar',
  props: {
    answers: { required: true },
    question: { required: true },
  },
  computed: {},
  methods: {

    getTitle (answer) {
      return Lang.get('review.answer_option.like.' + answer.answer) + ' <br /> ' + answer.percentage
    },

    getIconClass (answer) {
      return answer == 'agree' ? 'icon-like' : 'icon-dislike'
    },

    calculateStyle (answer) {
      if (answer.answer === 'disagree') {
        return `width:${answer.percentage_numeric}%; background-color:#4d2bff;`
      } else {
        return `width:${answer.percentage_numeric - 0.1}%; background-color:#251672;`
      }
    },

  },
}
</script>

<style scoped>
.progress{
  display: -webkit-box
}
</style>
